import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex, Separator, Tabs } from '@radix-ui/themes';
import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useProfile } from '../../hooks/useProfile';
import { getAddedAccountsToProfile } from '../../utils/mod';
import { LinkedWallet } from '../LinkedWallet';
import { ConnectedWallets } from './ConnectedWallets';
const tabsListStyles = {
    '--accent-indicator': 'var(--accent-10)',
    boxShadow: 'inset 0 -1px 0 0 var(--gray-a6)',
    flexShrink: 0,
};
const tabsContentStyles = { flexGrow: 1, minHeight: 0 };
const separatorStyles = {
    backgroundColor: 'var(--gray-a5)',
    flexShrink: 0,
};
export function ProfileWallets(props) {
    const { setShouldOpenConnectWalletsModal, data, onLogin, onMerge, onError } = props;
    const { profileSummary } = props.data;
    const { t } = useTranslation();
    const addedAccountsToProfile = profileSummary ? getAddedAccountsToProfile(profileSummary) : [];
    const { compatibleAccounts } = useProfile({
        addedAccounts: addedAccountsToProfile,
    });
    const tabs = {
        addedWallets: { id: 'added-wallets', title: t('Linked Wallets') },
        connectedWallets: { id: 'connected-wallets', title: t('Unlinked Wallets') },
    };
    const [selectedTab, setSelectedTab] = useState(tabs.addedWallets.id);
    const allAccounts = [...compatibleAccounts, ...addedAccountsToProfile];
    const linkedAccounts = allAccounts.filter((account) => !account.walletType);
    return (_jsx(Flex, { asChild: true, direction: "column", flexGrow: "1", minHeight: "0", children: _jsxs(Tabs.Root, { value: selectedTab, onValueChange: setSelectedTab, children: [_jsx(Tabs.List, { style: tabsListStyles, children: Object.values(tabs).map((tab) => (_jsx(Box, { flexGrow: "1", asChild: true, children: _jsx(Tabs.Trigger, { value: tab.id, children: tab.title }) }, tab.id))) }), _jsx(Tabs.Content, { value: tabs.addedWallets.id, style: tabsContentStyles, children: _jsx(Flex, { direction: "column", gap: "2", pt: "5", height: "100%", overflowY: "auto", children: linkedAccounts.map((account, index) => {
                            const { address, blockchain } = account;
                            return (_jsxs(Fragment, { children: [index > 0 && _jsx(Separator, { size: "4", style: separatorStyles }), _jsx(LinkedWallet, { account: account })] }, address + blockchain));
                        }) }) }), _jsx(Tabs.Content, { value: tabs.connectedWallets.id, style: tabsContentStyles, children: _jsx(Flex, { direction: "column", pt: "5", height: "100%", children: _jsx(ConnectedWallets, { accounts: allAccounts, setShouldOpenConnectWalletsModal: setShouldOpenConnectWalletsModal, data: data, onLogin: onLogin, onMerge: onMerge, onError: onError }) }) })] }) }));
}
